import { get, post, del } from '../utils/networking';

export interface SSOConnection {
  id: number;
  connectionType: string;
  status: string;
  entraIdDomain?: string;
  createdAt: string;
}

export interface SSOStatusResponse {
  enabled: boolean;
  connections: SSOConnection[];
}

export interface EnableSSORequest {
  connectionType: 'ENTRA_ID';
  entraIdTenantId?: string;
  entraIdClientId?: string;
  entraIdClientSecret?: string;
  entraIdDomain?: string;
}

export interface EnableSSOResponse {
  connectionId: number;
}

export async function getSSOStatus(organizationId: number): Promise<SSOStatusResponse> {
  return get<SSOStatusResponse>(`/api/organizations/${organizationId}/sso`);
}

export async function enableSSO(
  organizationId: number,
  data: EnableSSORequest
): Promise<EnableSSOResponse> {
  return post<EnableSSOResponse>(`/api/organizations/${organizationId}/sso`, data);
}

export async function disableSSO(
  organizationId: number,
  connectionId: number
): Promise<void> {
  return del(`/api/organizations/${organizationId}/sso/${connectionId}`);
}
